export const LOCALE_FALLBACK = 'en';
export const AVAILABLE_LANGUAGES = ['en', 'de'] as const;

export type Language = typeof AVAILABLE_LANGUAGES[number];
